/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

export const types = {
  SET_ACTIVE_HEADER: "[UI] Set Active Header",
  SHOW_PORTAL_ERROR: "[UI] Show Portal Error",
  HIDE_PORTAL_ERROR: "[UI] Hide Portal Error",
  SET_COLCON_FILTER_DP: "[UI] Set ColCon Filter for DP",
  REMOVE_COLCON_FILTER_DP: "[UI] Remove ColCon Filter for DP",
  SET_ACTIVE_VIEW_COL: "[UI] Set Active View for COL",
  REMOVE_ACTIVE_VIEW_COL: "[UI] Remove Active View for COL",
  SET_ACTIVE_VIEW_CON: "[UI] Set Active View for CON",
  REMOVE_ACTIVE_VIEW_CON: "[UI] Remove Active View for CON",
  VALIDATE_CONNECTOR: "[UI] Validate connector",
  VALIDATE_CONNECTOR_SUCCESS: "[UI] Validate connector success",
  VALIDATE_CONNECTOR_FAILED: "[UI] Validate connector failed",
  REMOVE_VALIDATE_CONNECTOR: "[UI] Remove Validate connector",
};
//
// ─── SET ACTIVE HEADER ACTIONS ────────────────────────────────────────────────────
//

export const SetActiveHeader = (item) => ({
  type: types.SET_ACTIVE_HEADER,
  payload: item,
});

//
// ─── PORTAL ERROR ACTIONS ────────────────────────────────────────────────────
//
export const showPortalError = (item) => ({
  type: types.SHOW_PORTAL_ERROR,
});
export const hidePortalError = (item) => ({
  type: types.HIDE_PORTAL_ERROR,
});
//
// ─── SET COL CON FILTERS FOR DATAPIPE ────────────────────────────────────────────────────
//
export const setColConFilterForDP = (filter) => ({
  type: types.SET_COLCON_FILTER_DP,
  payload: filter,
});
export const removeColConFilterForDP = () => ({
  type: types.REMOVE_COLCON_FILTER_DP,
});

// ─── SET ACTIVE VIEW COLLECTOR ACTIONS ────────────────────────────────────────────────────
//

export const SetActiveViewForCOL = (view) => ({
  type: types.SET_ACTIVE_VIEW_COL,
  payload: view,
});
export const RemoveActiveViewCol = () => ({
  type: types.REMOVE_ACTIVE_VIEW_COL,
});

//

// ─── SET ACTIVE VIEW CONNECTOR ACTIONS ────────────────────────────────────────────────────
//
export const SetActiveViewForCON = (view) => ({
  type: types.SET_ACTIVE_VIEW_CON,
  payload: view,
});
export const RemoveActiveViewCon = () => ({
  type: types.REMOVE_ACTIVE_VIEW_CON,
});
//
export const ValidateConnector = (id) => ({
  type: types.VALIDATE_CONNECTOR,
  payload: id,
});
export const ValidateConnectorSuccess = (status) => ({
  type: types.VALIDATE_CONNECTOR_SUCCESS,
  payload: status,
});
export const ValidateConnectorFail = (status) => ({
  type: types.VALIDATE_CONNECTOR_FAILED,
  payload: status,
});
export const RemoveValidateConnector = () => ({
  type: types.REMOVE_VALIDATE_CONNECTOR,
});
